import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PayrollGridComponent } from '../modules/payroll/payroll-grid/payroll-grid.component';
import { PayrollPreviewComponent } from '../modules/payroll/payroll-preview/payroll-preview.component';
import { PayrollManagement } from '../tools/payroll-management';

@Injectable({
  providedIn: 'root'
})

// FIXME: CanDeactivate is deprecated.
// see canDeactivateCorrectionsGuard for proper usage of CanDeactivateFn
export class CanDeactivatePayrollGuard {
  constructor(private payrollMgmt: PayrollManagement) {}

  canDeactivate(
    c: PayrollGridComponent | PayrollPreviewComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (c instanceof PayrollGridComponent) {
      return this.payrollMgmt.onPayrollDeactivate(
        c.payroll,
        true,
        c.rowData,
        nextState,
        c.sessionData
      );
    } else {
      return this.payrollMgmt.onPayrollDeactivate(c.payroll, false, null, nextState);
    }
  }
}
